import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { addClientsToGroup } from '@redux/features/groupsSlice';
import { getClients } from '@redux/features/clientsSlice';
import { Checkbox } from 'components/Checkbox';
import { Modal } from 'components/Modal';
import { Input } from 'components/Input';
import styles from './GroupPage.scss';

export const AddMembers = ({ group, isOpen, setIsOpen }) => {
  const { clients } = useSelector((state) => state.clients);
  const [selectedClients, setSelectedClients] = useState(new Set());
  const [searchClients, setSearchClients] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen) {
      dispatch(getClients());
      setSelectedClients(new Set());
      setSearchClients('');
    }
  }, [isOpen]);

  const filteredClients = useMemo(
    () =>
      clients.filter(
        (client) =>
          (searchClients === '' ||
            client.name.toLowerCase().includes(searchClients.toLowerCase()) ||
            client.surname.toLowerCase().includes(searchClients.toLowerCase())) &&
          client.id !== 0
      ),
    [clients, searchClients]
  );

  const currentMemberIds = useMemo(() => {
    if (group?.members) {
      return new Set(group?.members.map((m) => m.id));
    }
  }, [group]);

  const toggleClientSelection = (clientId) => {
    setSelectedClients((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(clientId)) {
        newSet.delete(clientId);
      } else {
        newSet.add(clientId);
      }
      return newSet;
    });
  };

  const handleAddSelectedClients = async () => {
    const result = await dispatch(addClientsToGroup({ groupID: group.id, clientIDs: selectedClients }));

    if (result?.meta.requestStatus === 'fulfilled') {
      setSelectedClients(new Set());
      setIsOpen(false);
      setSearchClients('');
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} className={styles.modal}>
      <h3 className={styles.modalTitle}>Додати учасника до групи</h3>

      <div className={styles.formGroup}>
        <Input
          className={styles.searchInput}
          icon={faSearch}
          placeholder="Введіть ім'я або прізвище..."
          value={searchClients}
          onChange={(e) => setSearchClients(e.target.value)}
        />
      </div>

      <div className={styles.clientsList}>
        {clients.length > 0
          ? filteredClients.map((client) => {
              const isCurrentMember = currentMemberIds.has(client.id);
              const isSelected = selectedClients.has(client.id);

              return (
                <div
                  key={client.id}
                  className={cn(styles.clientCard, {
                    [styles.selected]: isSelected,
                    [styles.disabled]: isCurrentMember,
                  })}
                  onClick={!isCurrentMember ? () => toggleClientSelection(client.id) : undefined}
                >
                  <div className={styles.clientInfo}>
                    <div className={styles.clientAvatar}>
                      {client.surname[0]}
                      {client.name[0]}
                    </div>
                    <h4 className={styles.clientName}>
                      {client.surname} {client.name}
                    </h4>
                  </div>
                  {isCurrentMember ? (
                    <span className={cn(styles.clientStatus, styles.alreadyMember)}>Вже в групі</span>
                  ) : (
                    <Checkbox checked={isSelected} />
                  )}
                </div>
              );
            })
          : 'Завантаження...'}
      </div>

      <div className={styles.formActions}>
        <button type='button' className={styles.btnSecondary} onClick={() => setIsOpen(false)}>
          Скасувати
        </button>
        <button
          type='button'
          className={styles.btnPrimary}
          onClick={handleAddSelectedClients}
          disabled={selectedClients.size === 0}
        >
          Додати вибраних ({selectedClients.size})
        </button>
      </div>
    </Modal>
  );
};
